// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * API endpoint for uploading files associated with assets.
 * Provides functionality to attach documents, images, or other files
 * to specific assets in the system.
 */
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a file and associates it with a specific asset.
 * The file is stored privately and can only be accessed by authorized users.
 * Uses the general file upload service with asset-specific context.
 *
 * @param id - Unique identifier of the asset to associate the file with
 * @param file - File object to upload (from file input or drag-and-drop)
 * @returns Promise resolving to the upload response
 * @throws Will throw an error if the file upload fails or if the file is invalid
 */
export async function uploadAssetFile(id: string, file: File) {
  return uploadFile(file, {
    context: 'ASSET_FILE',
    isPublic: false,
    entityId: id,
  });
}
